<template>
  <b-card-group deck class="mb-3">
    <b-card no-body img-top v-for="i in count" :key="i" class="mr-2">
      <b-skeleton-img card-img="top" :height="height"></b-skeleton-img>
      <b-card-body>
        <b-skeleton animation="wave" width="85%"></b-skeleton>
        <b-skeleton animation="wave" width="55%"></b-skeleton>
      </b-card-body>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  name: 'SkeletonEvent',
  props: {
    count: {
      type: Number,
      default() {
        return 3
      }
    },
    height: {
      type: String,
      default() {
        return '160'
      }
    }
  }
}
</script>

<style scoped>

</style>
